import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import * as styles from './UnlockChatButton.css';

type TProps = {
  onClick: () => void;
};

export const UnlockChatButton: React.FC<TProps> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <Button fullWidth theme="fill_white_primary" onClick={onClick}>
        Разблокировать
      </Button>
    </div>
  );
};
